
export function createUser(data) {
    localStorage.setItem('account', JSON.stringify(data))

}

export function setToken(token) {
    localStorage.setItem('token', token)

}

export function getToken() {
    return localStorage.getItem('token');
}

export function getUser() {
    return localStorage.getItem('account')

}

export function clearUsers() {
    localStorage.removeItem('account')
    localStorage.removeItem('token')
}

export function clearToken() {
    localStorage.removeItem('token')

}


